import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'titleCasePipe'
})
export class TitleCasePipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): string {
    if (!value) {
      return value;
    }
    return value
      ?.split(' ')
      ?.map((letters: string) => {
        if (letters.length <= 1) {
          return letters.toUpperCase();
        }
        return `${letters[0]?.toUpperCase()}${letters?.substr(1)?.toLowerCase()}`;
      })
      ?.join(' ');
  }
}
